<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin-left: 20px;">
          <div>
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;margin:10px;">
              如何将查询小程序链接到公众号菜单上,以统一发布成绩和查询成绩入口?</div>
            <div style="font-size:16px;padding-top: 10px;margin:10px;">
              <div>接入非常简单,您首先要有公众号菜单权限,以便配置菜单.</div>
              <div>详细配置说明请扫码打开“快查成绩”微信小程序,用发布成绩的老师账号登录,然后在“发布成绩”点击蓝色的“+”按钮,然后再点击“统一查询”可查看详细的接入步骤和复制相关路径.</div>
                <div style="display: flex;flex-direction:column;">
<!--                  <div
                    style="font-size: 18px;margin-top: 20px;text-align: center;color:red;width: 200px;height: 200px;">
                    快查成绩
                  </div> -->
                  <div><img src="/score/images/kccj_qrcode.jpg" style="width: 200px;height: 200px;" />
                  </div>
                </div>
            </div>
          </div>




        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    created() {

    },
    methods: {

    },
    watch: {

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowStyle {
    display: flex;
    justify-content: left;
    padding-left: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/add_to_pubsite.vue